import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  multipleChoiceConditionFromModel,
  validateMultipleChoiceCondition,
  type MultipleChoiceState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const MULTIPLE_CHOICE_STEP_TYPE_NAME =
  CONDITION_NAMES[Condition.MULTIPLE_CHOICE];

export const MULTIPLE_CHOICE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<MultipleChoiceState>>,
): ConditionType<MultipleChoiceState, Condition.MultipleChoice> => ({
  name: MULTIPLE_CHOICE_STEP_TYPE_NAME,
  description(state) {
    if (!state.questionText) {
      return t("No question configured");
    }
    if (state.answers.length === 0) {
      return t('Question: "{{question}}" (no answers)', {
        question: state.questionText,
      });
    }
    return t('"{{question}}" is one of: {{answers}}', {
      question: state.questionText,
      answers: state.answers.join(", "),
    });
  },
  Details(props: ConditionTypeDetailsProps<MultipleChoiceState>) {
    return React.createElement(Details, props);
  },
  empty: { questionText: "", answers: [] },
  fromModel(model) {
    return multipleChoiceConditionFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.MULTIPLE_CHOICE,
      questionText: state.questionText,
      answers: state.answers,
    };
  },
  valid(state) {
    return validateMultipleChoiceCondition(state).valid;
  },
});
